import * as Highcharts from 'highcharts';

import {Component, Inject, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {
  AdvancedCharts,
  ResidualsVSFitted
} from 'shared/dtos/cockpit/advancedCharts/advanced-charts';
import {DataStorageService} from 'shared/services/data-storage.service';
import {
  ChartTemplateService,
  ChartType,
  Xaxis,
  Yaxis
} from '../../../../cockpit-shared/charts-templates/chart-template.service';
import {CockpitChartComponent} from '../../../../cockpit-shared/cockpit-content-component';

@Component({
  selector: 'app-chart-dialog-residuals-vs-fitted',
  templateUrl: './chart-dialog-residuals-vs-fitted.component.html',
  styleUrl: './chart-dialog-residuals-vs-fitted.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartDialogResidualsVsFittedComponent
  extends CockpitChartComponent
  implements OnInit
{
  residualsVSFitted: ResidualsVSFitted;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly dataStorageService: DataStorageService,
    private readonly translasteService: TranslateService
  ) {
    super();
  }

  ngOnInit() {
    this.dataStorageService
      .getAdvancedChartsData()
      .then((data: AdvancedCharts) => {
        if (data?.residualsVSFitted) {
          this.residualsVSFitted = data.residualsVSFitted;
          this.initialize(this.residualsVSFitted);

          this.translasteService.onLangChange.subscribe(() => {
            const svgContainer = document.getElementById(
              'svgChartResidualsVsFitted'
            );
            if (svgContainer) {
              this.initialize(this.residualsVSFitted);
            }
          });
        }
      });
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  initialize(data: ResidualsVSFitted) {
    this.chartTemplateService.chartname = 'residualsVsFitted';
    this.initHighCharts(data);
  }

  private initHighCharts(data: ResidualsVSFitted) {
    const series = JSON.parse(
      this.chartTemplateService.translateChart(data.series)
    );

    const chartType = {
      type: 'scatter'
    } as ChartType;

    const chartTitle = {
      text: this.translasteService.instant(
        'm1.sprint5.cockpit.card.chart.grafischerModellcheck.residualsVsFitted.title'
      ),
      style: {color: '#333333', fontSize: '18px', fontWeight: 'bold'}
    };

    const xAxis = {
      title: {
        text: this.translasteService.instant(
          'm1.sprint5.cockpit.card.chart.grafischerModellchek.residualsVsFitted.x-Achse'
        )
      }
    } as unknown as Xaxis;

    const yAxis = {
      title: {
        text: this.translasteService.instant(
          'm1.sprint5.cockpit.card.chart.grafischerModellcheck.residualsVsFitted.y-Achse'
        )
      }
    } as unknown as Yaxis;

    const legend = {reversed: false};
    const tooltip = {
      useHTML: true,
      // eslint-disable-next-line object-shorthand
      formatter: function () {
        return `<svg width="16" height="16">${this.point.series.legendSymbol.element.outerHTML}</svg>${this.series.name}</b><br/>
        <span style="color:${this.series.color}">x</span>: <b>${this.point.x}</b><br/>
        <span style="color:${this.series.color}">y</span>: <span style="font-weight:bold;">${this.point.y}</span><br/>`;
      }
    };

    const stacking = null;

    this.chartTemplateService.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      stacking,
      tooltip,
      chartType
    );

    Highcharts.chart(
      'svgChartResidualsVsFitted',
      this.chartTemplateService.json,
      thechart => this.callBackFuncToNormalizeBarChart(thechart)
    );
  }

  private callBackFuncToNormalizeBarChart(thechart: Highcharts.Chart) {
    this.chart = thechart;
    thechart.reflow();
  }
}
